import { create } from 'zustand'

/**
 * Unapplied query edits, by widget path and then field name. Shared by the Query tab and the
 * query overlay on the widget, and applied only on Run, so the widget does not re-query on every keystroke.
 */
const usePendingQueryStore = create<Record<string, Record<string, string>>>()(() => ({}))
const NO_PENDING_QUERIES: Record<string, string> = {}

export function usePendingQueries(path: string | null): Record<string, string> {
  return usePendingQueryStore(st => (path && st[path]) || NO_PENDING_QUERIES)
}

/** Keeps an edit pending, or drops it once it matches the query the widget already has */
export function editPendingQuery(path: string, name: string, value: string, appliedValue: unknown) {
  const isApplied = value === (appliedValue ?? '')
  usePendingQueryStore.setState(st => {
    const { [name]: _replaced, ...others } = st[path] ?? {}
    return { ...st, [path]: isApplied ? others : { ...others, [name]: value } }
  })
}

/** Removes and returns the widget's pending edits, to apply them */
export function takePendingQueries(path: string): Record<string, string> {
  const pending = usePendingQueryStore.getState()[path] ?? NO_PENDING_QUERIES
  usePendingQueryStore.setState(st => {
    const { [path]: _taken, ...others } = st
    return others
  }, true)
  return pending
}
